import { Component, OnInit, AfterViewInit, OnDestroy, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, tap } from 'rxjs';
import { StackchartServiceService } from '../../stackchart-service.service';
import Stock from 'highcharts/modules/stock';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { SignificanceService } from 'src/app/common/services/significance.service';
Stock(Highcharts);

@Component({
  selector: 'app-stackedbarchart2',
  template: '<div [id]="\'chart-container\' + id" [style.height]="dynamicHeight"></div>'
})


export class Stackedbarchart2ComponentCustom implements OnInit, AfterViewInit, OnDestroy {
   
  Highcharts: typeof Highcharts = Highcharts;
  chartMainData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
 
  defaultCategories1: any;
  max: any;
  min: any;
  maxBarValue = 0;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = "#ff0000";
  maxDataPoints: any = 8;
  maxSeries: any;
 
  userselectedchartdata: any;
  categoryColorMap: { [key: string]: string } = {};

  seriesData: any[] = [];
  StackChartData: any[] = [];
  chart: any;
  custom: any[] = [];
  ChartProperties: any;
  event: any;
  data: any;
  chartCategories: any;
  categoryImages: any[] = [];
   @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any ;
  @Input() layoutWidth?: number;
  hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;
  // Dynamic height property based on popUp state, layout width and number of categories
  get dynamicHeight(): string {
    if (this.popUp) return '30rem';
    if (this.layoutWidth === 1 && this.chartCategories?.length > 0) {
      // 5rem per category gives each bar enough vertical room for significance labels
      const computed = this.chartCategories.length * 5;
      return `${Math.max(computed, 24)}em`;
    }
    return this.height;
  }
  
 private subscriptions: Subscription = new Subscription();
 private viewInitialized = false;
  DefaultConfidenceLevel: any = "";
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  configuredProperties: any;

  ngOnInit(): void {
  
    if(this.isOutput){
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.applyCustomMetricExtensions();
      if (this.configuredProperties?.sort == "default") this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      
      this.properties = this.configuredProperties != undefined ? this.configuredProperties : {};
      
      // Prepare data in ngOnInit
      this.preparemainChartData(this.customData);
      
      // Create a data structure for getData
      const chartDataStructure = [{ data: this.chartMainData }];
      this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");
      
      // Subscribe to config changes
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      
    }
    else{
       this.http.get<any>('assets/Data/StackData.json').subscribe((data: any) => {
       
        this.jsonData = data;
        this.data = data[0];
        this.StackChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.decimalRoundOff = 2;
        this.properties.showLegend = true;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        //this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

        this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
      });
    }
  }
   private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        if (this.configuredProperties?.sort == 'default') this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.updateSig();
      }
    }
  }
  ngAfterViewInit(): void {
    // Render chart after view is initialized (only for isOutput mode)
    if(this.isOutput){
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        let docEle = document.getElementById('chart-container' + this.id);
        if (docEle != null) {
          docEle.innerHTML = '';
        }
        this.cdr.detectChanges();
        this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
        // Mark view as initialized after first render
        this.viewInitialized = true;
      }, 0);
    }
  }

  /**
   * Extract the part after pipe character if it exists, otherwise return original
   * e.g., "Brand Consider Purpose | Consider Purpose 01" => "Consider Purpose 01"
   */
  extractKeyAfterPipe(key: string): string {
    if (key && typeof key === 'string' && key.includes('|')) {
      const parts = key.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : key.trim();
    }
    return key || '';
  }

  constructor(private http: HttpClient,  private cdr: ChangeDetectorRef,private stackService: StackchartServiceService,   private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService, private route: ActivatedRoute, private significanceService: SignificanceService) { }
 updateSig() {
    this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
    this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
    
    // this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
    // this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
   if (this.hasCustomMetricSignificance) {
     this.properties.datalabelStyle = "default";
   } else {
     this.properties.datalabelStyle =
       this.significanceValue == "None"
         ? "default"
         : "sigChange";
   }


   if (
     this._configService.isIndexSelected &&
     !this.hasCustomMetricIndex
   ) {
     this.properties.datalabelStyle = "index";
   }
    this.preparemainChartData(this.customData);
    
    // Create a data structure for getData
    const chartDataStructure = [{ data: this.chartMainData }];
    this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");

    // Mark view as initialized after first render
    if (!this.viewInitialized) return;

    let docEle = document.getElementById('chart-container' + this.id)
    if (docEle != null) {
      docEle.innerHTML = '';
    }

    this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
  }

    getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      // this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;


      chartData[0].data = this.chartMainData
        .filter((item: any) => item['Label'] !== 'NA' && item['Label'] !== null && !(parseFloat(item['Rounded Value']) < 0))
        .map((item: any, idx: number) => ({ ...item, XValue: idx + 1 }));

      if (chartData[0].data.length === 0) {
        this.seriesData1 = [];
        this.seriesData = [];
        return;
      }

      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name



// Get all unique series names
const allSeriesNames = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Series Name'])));

// Initialize seriesData1 as an array
this.seriesData1 = [];

// Initialize min/max
this.max = 0;
this.min = 0;
const allCategories = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Category Name'])));

// Loop through each series name
  allSeriesNames.forEach((seriesName: any, seriesIndex: any) => {
      const seriesData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === seriesName);
      
      // Calculate the min and max value for the y-axis for this series
      // maxValue = Math.max(...seriesData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      // minValue = Math.min(...seriesData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      // this.max = Math.max(this.max, maxValue + Math.ceil(maxValue * (this._configService.isRespondentLevel ? 0.10 : 0.20)));
      // this.min = Math.min(this.min, minValue + Math.ceil(minValue * (this._configService.isRespondentLevel ? 0.10 : 0.20)));

      // Prepare arrays for each property
      const categoryNames: string[] = [];
      const seriesNames: string[] = [];
      const isPercentArray: boolean[] = [];
      const yValues: number[] = [];
      const xValues: number[] = [];
      const indexValues: number[] = [];
      const actualIndexValues: any[] = [];

      allCategories.forEach((categoryName, categoryIndex) => {
        const item = seriesData.find((d: { [x: string]: string }) => d['Category Name'] === categoryName);
        
        if (!item) {
          categoryNames.push('');
          seriesNames.push('');
          isPercentArray.push(false);
          yValues.push(0);
          xValues.push(categoryIndex);
          indexValues.push(0);
          actualIndexValues.push(null);
        } else {
          categoryNames.push(item['Category Name']);
          seriesNames.push(item['Series Name']);
          isPercentArray.push(item["isPercentage"]);
          yValues.push(
            this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : 
            (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 
            (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0))
          );
          xValues.push(categoryIndex);
          indexValues.push(
            this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : 
            (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 
            (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0))
          );
          actualIndexValues.push(item['ActualIndexValue']);
        }
      });
      

      // Create series object
      // Look up color from global color map using series name
      // 
      const extractedSeriesName = seriesName;
      let seriesColor = seriesData[0]['color'];

      const globalColorMap = this._configService.getGlobalColorMap();

      if (globalColorMap) {
        const matchedKey = Object.keys(globalColorMap).find(
          key => key.includes(extractedSeriesName)
        );

        if (matchedKey) {
          seriesColor = globalColorMap[matchedKey];
        }
        }
      
      
      this.seriesData1.push({
        name: seriesName,
        type: 'bar',
        color: this.properties.showPattern ? this.getPatternForImage(this.stackService.patternImages[seriesIndex % this.stackService.patternImages.length]) : 
               this.properties.gradientBarColor ? seriesData[0]['colorLinearGradient'] : seriesColor,
        visible: true,
        zIndex: 2,
        dataLabels: {
          borderWidth: 0,
        },
        data: yValues,
        categoryNames: categoryNames,
        seriesNames: seriesNames,
        isPercentArray: isPercentArray,
        xValues: xValues,
        indexValues: indexValues,
        actualIndexValues: actualIndexValues,
        changeValue: seriesData.map((seriesItem: { [x: string]: string }) => (seriesItem["Change value vs PY"])),
        significanceValue: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Significance"])),
        significanceValue2: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Significance2"])),
        sampleSizeValues: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Sample size"])),
        roundedValue: seriesData.map((seriesItem: { [x: string]: string }) => seriesItem["Rounded Value"]),
        tooltip: [],
        isPercentage: seriesData[0]["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: seriesData[0]["Significance_Value"],
        isAdditionalKPI: seriesData[0]["isAdditionalKPI"] ?? false    // ADD THIS
      });

   
    });

// Split standard columns from the additional KPI series FIRST (before max calc)
const standardSeries = this.seriesData1.filter((s: any) => !s.isAdditionalKPI);
const kpiSeries      = this.seriesData1.filter((s: any) =>  s.isAdditionalKPI);

  // ✅ FIX: compute y-axis using STACK TOTALS (not per-series max)
if (this.properties?.stacking) {
  // percent stacking
  this.min = 0;
  this.max = 100;
} else {
  const maxTotal = this.getStackTotalsMax(standardSeries);
  const pad = Math.ceil(maxTotal * (this._configService.isRespondentLevel ? 0.10 : 0.20));
  this.min = 0;
  this.max = maxTotal + pad;
}



// Check if any value is 0 and set min to 0
if (this.seriesData1.filter((x: any) => x.value == 0).length > 0) {
  this.min = 0;
}

// Extract category names from all data (without adding empty string at the beginning)
this.categories = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Category Name'])));
this.chartCategories = this.categories;

// Assign seriesData1 to seriesData so the chart can use it
this.seriesData = this.seriesData1;

// Compute stack total per category (sum of all standard series) for positioning the KPI label
const categoryCount = allCategories.length;
const stackTotals = Array(categoryCount).fill(0);
standardSeries.forEach((s: any) => {
  (s.data || []).forEach((v: number, i: number) => { stackTotals[i] += (v || 0); });
});

const kpiSeries0 = kpiSeries[0];
if (kpiSeries0) {
  kpiSeries0.kpiActualValues = [...(kpiSeries0.roundedValue || kpiSeries0.data)]; // save real values for label
  kpiSeries0.kpiSeriesName   = kpiSeries0.name;
  kpiSeries0.type = 'scatter';
  kpiSeries0.marker = { enabled: false, radius: 0, states: { hover: { enabled: false } } };
  kpiSeries0.enableMouseTracking = false;
  kpiSeries0.showInLegend = !!this.popUp;
  kpiSeries0.legendSymbol = 'rectangle';
  kpiSeries0.color = 'grey';
  kpiSeries0.data = stackTotals.map(() => this.max); // y = top of bar
  kpiSeries0.dataLabels = {
    enabled: true,
    useHTML: true,
    verticalAlign: 'top',
    align: 'center',
    y: -8,
    overflow: 'allow',
    crop: false,
  };
}


this.seriesData1 = [...kpiSeries, ...standardSeries];
this.seriesData  = this.seriesData1;
 

    }
    else {
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;
      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name
      const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);


      //calculate the min and max value for the y-axis
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      this.max = maxValue + Math.ceil(maxValue * 0.10);
      this.min = minValue + Math.ceil(minValue * 0.10);
      //loop throught he filtered data
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

        //extract Value,if null plot as 0
        value: item['Value'] == null ? 0 : parseFloat(item['Value']),
        //if lowsample is selected,if Value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant ? value : 0),
        //name for each datapoint
        name: item['Category Name'],

        //apply pattern/gradient bar color or default color based on selection
        color: this.properties.showPattern ? this.getPatternForImage(this.stackService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],

        visible: true,
        zIndex: 2,
        type: 'bar',
        dataLabels: {

          borderWidth: 0,

        },
       
  seriesName:item['Series Name'],
          y: !lowSample1 ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : 0),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
        //extract changeVs value
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Change value vs PY"])),
        //extract significance value
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        //extract significance2 value
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        //extract sample size value
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        //extract Value
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Value"]),
        //include tooltip to reflect the datalabel property selected
        tooltip: [],


      }));


      //extract category names
      this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
      this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

      // //include additional series for marker
      // indiaData.forEach((item: { [x: string]: string }, index: number) => {
      //   let markerStyle = this.properties.markerStyle;
      //   let offsetMultiplier = 0.03;
      //   // Change marker style to triangle if 'Value' is negative and marker style is 'triangle'
      //   if (parseFloat(item['Value']) < 0 && markerStyle === 'triangle') {
      //     markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
      //   }
      //   if (parseFloat(item['Value']) < 50 && parseFloat(item['Value']) > 0) {
      //     offsetMultiplier = 0.1; // Further increase offset if value is less than 50
      //   }
      //   if (parseFloat(item['Value']) <= 80 && parseFloat(item['Value']) >= 50 && parseFloat(item['Value']) > 0) {
      //     offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
      //   }
      //   this.seriesData1.push({
      //     name: item['Category Name'],
      //     type: 'scatter',
      //     zIndex: 1,
      //     marker: {
      //       symbol: markerStyle,
      //       fillColor: 'red',
      //       lineColor: 'red',
      //       lineWidth: 2,
      //     },
      //     enableMouseTracking: false,
      //     showInLegend: false,
      //     visible: this.properties.marker === 'enable',
      //     data: [{
      //       name: item['Category Name'],
      //       y: !lowSample1 ? (item['Value'] == null || parseFloat(item['Value']) === 0) ? null :
      //         parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
      //           parseFloat(item['Value']) + (0.04 * parseFloat(item['Value'])) :
      //         (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant && item['Value'] != null && parseFloat(item['Value']) !== 0) ?
      //           parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (0.03 * parseFloat(item['Value'])) :
      //             parseFloat(item['Value']) + (0.05 * parseFloat(item['Value'])) : null,
      //       x: index + 1,
      //       z: parseFloat(item['Sample Size']) > this.stackService.sampleSizeConstant ?
      //         0 :
      //         (item['Value'] != null ?
      //           parseFloat(item['Value']) :
      //           0),
      //     }],
      //   });
      // });



    }
  }

  /**
   * Cleans up names by removing text before the pipe character (|)
   * e.g., "brands|Brand 01" becomes "Brand 01"
   */
  cleanName(name: string): string {
    if (name && typeof name === 'string' && name.includes('|')) {
      const parts = name.split('|');
      if (parts[1]?.toLowerCase().includes('yes')) {
        return name.trim();
      }
      if (parts.length > 2) {
        return parts.slice(-2).join('|').trim();
      }
      return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim();
    }
    return name || '';
  }

 preparemainChartData(data: any) {
    let i = 0;
    this.chartMainData = [];

    data.metric_value.forEach((lev2: any) => {
      const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
      lev2.data.forEach((dataArr: any) => {
        // Clean raw names by removing text before |
        const cleanedColChild = this.cleanName(dataArr.colChild);
        const cleanedOption = this.cleanName(lev2.option);

        let d1 = {
          
          // "Series Name": this.properties.StackFormat=="On"? this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? cleanedColChild : cleanedColChild : cleanedOption,
          // "Category Name": this.properties.StackFormat=="On"? cleanedColChild : this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? cleanedColChild : cleanedColChild,
          "Series Name": this.properties.StackFormat=="On"? cleanedColChild : cleanedOption,
          "Category Name": this.properties.StackFormat=="On"? cleanedOption : cleanedColChild,
          "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Change value vs PY": dataArr.changeVsPY==null?"NA":dataArr.changeVsPY,
          "Significance": "-1",
          "Sample size": dataArr.baseValueforLSorIs,
          "Significance2": "1",
          "XValue": ++i,
           "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
          // "isPercentage":
          //   hasPercentageExtension
          //     ? false
          //     : true,
          "Sig_LowerLimt": this.Sig_LowerLimt,
          "Sig_UpperLimt": this.Sig_UpperLimt,
          "Significance_Value": dataArr.Significance_Value,
          "color": dataArr.color,
          "colorLinearGradient": dataArr.colorLinearGradient,
          "isAdditionalKPI": lev2.isAdditionalKPI ?? false   // read from series level, not data-point level
        }
        this.chartMainData.push(d1);
        if (!isNaN(d1["Rounded Value"])) {
          const rounded = Math.round(parseFloat(d1["Rounded Value"]) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if (this.configuredProperties) {
      if (this.configuredProperties?.sort == "ascending") {
        const sortedData = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in ascending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return 1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return -1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return a["Value"] - b["Value"];
        });
        this.chartMainData = sortedData;
      }
      if (this.configuredProperties?.sort == "descending") {
        const sortedDataDesc = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in descending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return -1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return 1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return b["Value"] - a["Value"]; // For descending order, reverse the comparison
        });
        this.chartMainData = sortedDataDesc;
      }
    }

    // this.chartMainData=this.chartMainData.slice(0,1);
  }
  seriesObject: any = {};
  accessSeriesValues(islowSample: any) {
    const seriesObjects: any = {};
    const categories: string[] = [];
    const categoryImages: any[] = [];
    for (const series of this.StackChartData) {
      const seriesName = this.ChartProperties.StackFormat=="On"?series["Category Name"]:series["Series Name"]; //Access series name
      const roundedValue = series["Rounded Value"];
      let numericValue = (roundedValue === " " || roundedValue === null) ? 0 : Number(parseFloat(series["Value"]).toFixed(this.properties.decimalRoundOff));
      let label = (series.Label); //If any customised label to be used can be accessed from this property
      const change = parseFloat(series["Change value vs PY"]); //Change value compared to previous year
      const significance = parseFloat(series["Significance"]);
      const category =this.ChartProperties.StackFormat=="On"? series["Series Name"]:series["Category Name"]; //Access category names
      const sampleSize = series["Sample size"];
      const significance2 = series["Significance2"];
      const categoryImage = series["Category Image"];
     
      if(true){
      // Check if chartProperties.showNegative is false and series has negative values
      if (!this.properties.showNegative && numericValue < 0) {
        continue; // Skip this series
      }

      let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.stackService.sampleSizeConstant ? numericValue : 0);
      let pointWidth = category.length < 5 ? 70 : 45; //If categories are more than 5 then set pointwidth to 70
      let tooltip = "";
     if(this.properties.stackPosition=="BrandsinX"){
      if (!seriesObjects[seriesName]) {
        seriesObjects[seriesName] = {
          name: seriesName,
          data: [],
          label: [],
          roundedValue: [],
          changeValue: [],
          significanceValue: [],
          significanceValue2: [],
          sampleSizeValues: [],
          visible: true,
          pointWidth: pointWidth,
          tooltip: []
        };
      }
      seriesObjects[seriesName].data.push(finalvalue);
      seriesObjects[seriesName].roundedValue.push(roundedValue);
      seriesObjects[seriesName].label.push(label);
      seriesObjects[seriesName].changeValue.push(change);
      seriesObjects[seriesName].significanceValue.push(significance);
      seriesObjects[seriesName].significanceValue2.push(significance2);
      seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
      seriesObjects[seriesName].tooltip.push(tooltip);
      if (!categories.includes(category)) {
        categories.push(category);
      }
     }
     else{
      if (!seriesObjects[category]) {
        seriesObjects[category] = {
          name: category,
          data: [],
          label: [],
          roundedValue: [],
          changeValue: [],
          significanceValue: [],
          significanceValue2: [],
          sampleSizeValues: [],
          visible: true,
          pointWidth: pointWidth,
          tooltip: []
        };
      }
      seriesObjects[category].data.push(finalvalue);
      seriesObjects[category].roundedValue.push(roundedValue);
      seriesObjects[category].label.push(label);
      seriesObjects[category].changeValue.push(change);
      seriesObjects[category].significanceValue.push(significance);
      seriesObjects[category].significanceValue2.push(significance2);
      seriesObjects[category].sampleSizeValues.push(sampleSize);
      seriesObjects[category].tooltip.push(tooltip);

      if (!categories.includes(seriesName)) {
        categories.push(seriesName);
      }
     }

     
      // if (this.categoryImages) {
      //   categoryImages.push(categoryImage);
      // }
    }
    this.seriesData = Object.values(seriesObjects).map((item: any) => {
      return {
        name: item.name,
        data: item.data,
        label: item.label,
        color: item.color,
        changeValue: item.changeValue,
        roundedValue: item.roundedValue,
        visible: item.visible,
        significanceValue: item.significanceValue,
        significanceValue2: item.significanceValue2,
        sampleSizeValues: item.sampleSizeValues,
        pointWidth: item.pointWidth,
        showInlegend: item.showInLegend,
        tooltip: item.tooltip
      };
    }
    );

    this.seriesData.reverse(); // Reverse seriesData to get the first series below and then stack the rest
    this.chartCategories = categories;
    this.categoryImages = categoryImages;
  }
  }

 
  customization(): Observable<any> {
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
     return _.cloneDeep(this._customSnapshotService.getChartCustomization("Horizontal Stack Bar", snapshotTypeSelectedName, cohortType));
  }
  renderChart2(container2: any, data:any,properties: any) {
    localStorage.setItem("properties", JSON.stringify(properties));
    this.ChartProperties = properties;
   
    
    if(this.isOutput){
      if (!this.seriesData1 || this.seriesData1.length === 0) {
        const containerEl = document.getElementById(container2);
        if (containerEl) {
          containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size:0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      const seriesDataForFormatter = data;
      const categoriesForFormatter = this.categories;
      const categoryImagesForFormatter = this.categoryImages;
      const serviceBar = this.stackService;
     
      // 1 & 3 widget: show all bars (no scroll cap); 2, 4, 6 widget: cap at 2; 7 widget (small): cap at 3
      let maxCategoriesToShow: number | null =
        (this.layoutWidth === 2 || this.layoutWidth === 4 || this.layoutWidth === 6)
          ? 2
          : this.layoutWidth === 7
            ? (this.id === 0 ? 6 : 3) // large left widget: 6 bars; small right widgets: 3 bars
            : null; // null = show all

      const isTranspose = this.properties.StackFormat === 'On';

      const sampleSizeConstant = this.stackService.sampleSizeConstant;
      const configService = this._configService;
      let yAxisMaxValue = this.max;
      let yAxisMinValue = this.min;
      let tickInterval = Math.ceil(this.max / 10);
      let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
       let popUp = this.popUp;
      const isSingleBrand = this._configService.selectedSnapshotType?.toLowerCase().includes('single brand') ?? false;
      const popUpTransposeMax = 6;
      const enableCategoryScroll = (popUp && isTranspose)
        ? this.chartCategories.length > popUpTransposeMax
        : (!popUp && maxCategoriesToShow !== null && this.chartCategories.length > maxCategoriesToShow);
      const effectiveMax = (popUp && isTranspose) ? popUpTransposeMax : (maxCategoriesToShow ?? this.chartCategories.length);
      const xAxisMax = enableCategoryScroll
        ? effectiveMax - 1
        : this.chartCategories.length - 1;
   
      
      // To display plotbands
      const numPlotBands = this.chartCategories.length;
      if (this.ChartProperties.plotBands) {
        for (let i = 0; i < numPlotBands; i += 2) {
          const from = i + 0.5;
          const to = from + 1;
          plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.stackService.plotBandsdark : this.stackService.plotBandsColor, from, to });
        }
      }
      
      const containerEl = document.getElementById(container2);
      if (!containerEl) { return; }
      const hasKPI = this.seriesData1.some((s: any) => s.isAdditionalKPI);
      // "index" and "sigChange" render a second line (index/significance value) below the main value,
      // so they need more clearance above the bar. Other styles are single-line and can sit closer to the bar.
      const hasSigOrIndexLabel = properties.datalabelStyle === 'index' || properties.datalabelStyle === 'sigChange';
      const barDataLabelY = hasSigOrIndexLabel ? -30 : -22;
      this.chart = Highcharts.chart(containerEl, {
      chart: {
        type: 'bar',
        marginTop: hasKPI ? 10 : 10,
        spacingRight: hasKPI ? 25 : 10,
        backgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
        style: {
          fontFamily: this.stackService.textfont,
          zIndex: 1,
          overflow: 'visible',
          color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
        }
      },
      exporting: {
        enabled: false
      },

      // legend: this.stackService.customizeLegend(this.ChartProperties.showLegend,this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),
      legend: {
        enabled: !!this.popUp
      },

      title: {
        text:'',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          marginleft: '4%',
          fontFamily: this.stackService.textfont,
          fontSize: '2em'
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {
        // reversed: true,
        visible: true,
        lineWidth: 1,
        min: 0,
        max: xAxisMax,
        categories: this.chartCategories,
                gridLineWidth: this.properties.xaxisgridlines ? 1 : 0,
        labels: {
          enabled: false,
          rotation: this.stackService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          useHTML: popUp,
          style: {
            fontFamily: this.stackService.textfont,
            color: this.properties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.defaultThemeTextColor,
            whiteSpace: 'normal',
            fontSize: popUp ? '0.7rem' : '12px',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
            if (isSingleBrand) return '';
            const raw = String(this.value ?? '');
            const esc = (s: string) => s
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/\"/g, '&quot;')
              .replace(/'/g, '&#39;');

            if (popUp) {
              const chart = this.axis.chart;
              const categories = (this.axis.categories || []) as any[];
              const chartWidth = chart.plotWidth || 400;
              const numCategories = Math.max(categories.length, 1);
              const baseWidth = Math.floor(chartWidth / numCategories);
              const padding = 12;
              const minWidth = 80;
              const maxWidth = 200;
              const labelWidth = Math.min(Math.max(baseWidth - padding, minWidth), maxWidth);

              return `<div style="width:${labelWidth}px; white-space:normal; overflow:visible; text-overflow:clip; word-break:break-word; line-height:1.2; text-align:center; margin:0 auto;" title="${esc(raw)}">${esc(raw)}</div>`;
            }

            // Normal view: keep the old native axis label behavior
            return raw;
          },
    // formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
    //   // Calculate available width per label
    //   const chart = this.axis.chart;
    //   const categories = this.axis.categories || [];
    //   const chartWidth = chart.plotWidth || 400;
    //   const numCategories = Math.max(categories.length - 1, 1); // Exclude first empty category
      
    //   // Calculate base width per category with enhanced popup support
    //   const baseWidth = Math.floor(chartWidth / numCategories);
    //   const padding = popUp ? 15 : 8; // Reduced padding for popup to utilize more space
    //   const minWidth = popUp ? 120 : 80; // Higher minimum width for popups
    //   const labelWidth = Math.max(baseWidth - padding, minWidth);
  
    //   // Split label into max 2 lines, not breaking words
    //   function splitLabelToTwoLines(str: string, maxWidth: number) {
    //     // Estimate average character width (in px) - adjusted for better accuracy
    //     const avgCharWidth = popUp ? 6.0 : 6.5; // Slightly smaller char width for popup to fit more text
    //     const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
  
    //     const words = str.split(' ');
    //     let line1 = '';
    //     let line2 = '';
    //     let currentLine = '';
    //     let breakIndex = 0;
  
    //     // Build first line
    //     for (let i = 0; i < words.length; i++) {
    //       const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
    //       if (testLine.length <= maxCharsPerLine || !currentLine) {
    //         currentLine = testLine;
    //         breakIndex = i + 1;
    //       } else {
    //         break;
    //       }
    //     }
    //     line1 = currentLine;
  
    //     // Build second line with remaining words
    //     const remainingWords = words.slice(breakIndex);
    //     line2 = remainingWords.join(' ');
  
    //     // Truncate second line with ellipsis if needed
    //     if (line2.length > maxCharsPerLine) {
    //       line2 = line2.substring(0, maxCharsPerLine - 3).trim() + '...';
    //     }
  
    //     return line2 ? `${line1}<br/>${line2}` : line1;
    //   }
  
    //   let labelContent = String(this.value);
    //   labelContent = splitLabelToTwoLines(labelContent, labelWidth);
  
    //   // Determine text alignment based on number of lines
    //   const isMultiLine = labelContent.includes('<br/>');
    //   const textAlign = 'center';
  
    //   // If axisImage is enabled, show image instead
    //   if (properties.axisImage) {
    //     const categoryName = seriesDataForFormatter.find((s: any) => s.data.some((d: any) => d.name === this.value))?.data.find((d: any) => d.name === this.value)?.name;
    //           var index = categoriesForFormatter.indexOf(categoryName || String(this.value));
              
    //  if (index >= 0 && categoryImagesForFormatter[index]) {
    //   var category1 = serviceBar.baseImgPath + categoryImagesForFormatter[index] + '.png';
    //       return `<span style="display: inline-block; width: 2em; height: 2em; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
    //     } else {
    //       return '<span>No Image</span>';
    //     }
    //   } else {
    //     // Center-align text for single line, left-align for multiple lines
    //     const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
    //     return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0;" title="${String(this.value)}">${labelContent}</div>`;
    //   }
    // },
       
        },
        scrollbar: {
          enabled: enableCategoryScroll,
          height: 6, // Adjust the height of the scrollbar as needed
           barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          buttonBackgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          buttonBorderWidth: 0,
          buttonArrowColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        tickLength: 0,
        plotBands: plotBandsConfig,
      },
      yAxis: {
        visible: true,
        // gridLineWidth: this.ChartProperties.gridlines,
        gridLineWidth: this.ChartProperties.yaxisgridlines ? 1 : 0,
        labels: {
          enabled: false,
          style: {
            color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          },
        },
        // plotLines: [{
        //   value: 0,
        //   width: 1,
        //   zIndex: 4,
        //   visible:true
        // }],
        min: this.min,
        max: this.max,
        tickInterval: this.ChartProperties.stacking ? 10 : tickInterval,
        title: {
          text: '',
          fontFamily: this.stackService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },

        formatter: function () {
          if ((this as any).series?.userOptions?.isAdditionalKPI) return false;
          if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
          const content =
               `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${this.point.series.name}: </span>
            <b style="margin-left:4px;">${text}</b>
          </div>`;
 
  return content;
//         if (isDefaultTooltip != 'default') {
//           const content =
//                `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
//             <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
//             <span>${this.point.series.name}: </span>
//             <b style="margin-left:4px;">${text}</b>
//           </div>`;
 
//   return content;

          
//           }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 999; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.series.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }
        },
      } as any,

      plotOptions: {
        series: {
          animation: false,
        },
        scatter: {
          dataLabels: {
            allowOverlap: true,
            enabled: true,
            useHTML: true,
            overflow: 'allow',
            crop: false,
            formatter: function (this: any) {
              if (!this.series.userOptions.isAdditionalKPI) return '';
              const rawVal = this.series.userOptions.kpiActualValues?.[this.point.index];
              const color = properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.lightThemeTextColor;
              const fontSize = properties.dataLabelSize || '0.75rem';
              if (rawVal == null || rawVal === '') return `<div style="font-size:${fontSize};color:${color};font-weight:bold;white-space:nowrap;text-align:center;">NA</div>`;
              const decRound = properties.decimalRoundOff ?? 2;
              const numVal = !isNaN(Number(rawVal)) ? Number(Number(rawVal).toFixed(decRound)) : (String(rawVal).toUpperCase() === 'NA' ? 'NA' : rawVal);
              const isPercent = this.series.userOptions.isPercentage;
              const valStr = `${numVal}${isPercent && numVal !== 'NA' ? '%' : ''}`;
              const kpiName = this.series.userOptions.kpiSeriesName || this.series.name;

              if (properties.datalabelStyle === 'sigChange') {
                let changeText = this.series.userOptions.changeValue?.[this.point.index];
                if (changeText != null && isPercent) changeText = Number(changeText) * 100;
                const sigVal   = this.series.userOptions.Significance_Value;
                const sigLower = this.series.userOptions.Sig_LowerLimt;
                const sigUpper = this.series.userOptions.Sig_UpperLimt;
                const sigClass = sigVal < sigLower ? 'red' : sigVal > sigUpper ? 'green' : 'black';

                let changeHtml = '';
                if (changeText != null && changeText !== 'NA' && !isNaN(Number(changeText))) {
                  changeHtml = `<br/><span style="color:${sigClass};font-size:${fontSize};">(${parseFloat(Number(changeText).toFixed(1))}${isPercent ? '%' : ''})</span>`;
                }
                return `<div title="${kpiName}: ${valStr}" style="font-size:${fontSize};color:${color};font-weight:bold;white-space:nowrap;text-align:center;pointer-events:auto;cursor:default;">${valStr}${changeHtml}</div>`;
              }

              if (properties.datalabelStyle === 'index') {
                const rawIndex = this.series.userOptions.actualIndexValues?.[this.point.index];
                let indexStr = 'NA';
                if (rawIndex != null && String(rawIndex).toUpperCase() !== 'NA' && rawIndex !== -1 && rawIndex !== '-1') {
                  indexStr = String(Math.round(Number(rawIndex)));
                }
                const indexColor = rawIndex != null && indexStr !== 'NA' ? configService.CheckIndexColoring(indexStr) : 'black';
                const indexHtml = rawIndex != null ? `<br/><span style="color:${indexColor};font-size:${fontSize};">(${indexStr})</span>` : '';
                return `<div title="${kpiName}: ${valStr}" style="font-size:${fontSize};color:${color};font-weight:bold;white-space:nowrap;text-align:center;pointer-events:auto;cursor:default;">${valStr}${indexHtml}</div>`;
              }

              return `<div title="${kpiName}: ${valStr}" style="font-size:${fontSize};color:${color};font-weight:bold;white-space:nowrap;text-align:center;pointer-events:auto;cursor:default;">${valStr}</div>`;
            }
          }
        }, 
        bar: {
          //  pointWidth: 20, 
          pointWidth: this.getPointWidth(container2, this.chartCategories.length),
          stacking: this.ChartProperties.stacking ? 'percent' : 'normal',
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: this.ChartProperties.allowOverlap,
            enabled: this.ChartProperties.showDataLabel,
            color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
            // verticalAlign: this.ChartProperties.chartType === 'bar' ? 'top' : this.ChartProperties.dataLabelPosition,
            // align: this.ChartProperties.chartType === 'bar' ? 'center' : 'center',
            verticalAlign: 'top',
            align: 'center',
            x: 0,
            y: barDataLabelY,
            useHTML: true,
            overflow: 'allow',
            crop: false,
            
            // x: this.properties.StackFormat=="On" ? 0 : 50,
            // y: this.properties.StackFormat=="On" ? -20 : 0,
            // overflow: 'none',
            // crop: false,
            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
              fontSize: this.ChartProperties.dataLabelSize,
              fontFamily: this.stackService.textfont,
              fontWeight: "normal",
              whiteSpace: 'normal'
            },
            formatter: function (this: any) {
                if (properties.datalabelStyle == "index") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSizeValues[this.point.x],);

                  this.series.userOptions.tooltip[this.point.x] = text;

                  // let text2 = this.series.userOptions.roundedValue[this.point.x] === 0
                  //   ? serviceBar.nullValueText
                  //   : this.series.userOptions.roundedValue[this.point.x] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x] != null ? this.point.indexValue : serviceBar.nullValueText;

                let text2 = this.series.userOptions.actualIndexValues[this.point.x] == null
                    ? serviceBar.nullValueText
                    : this.series.userOptions.roundedValue[this.point.x] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x] != null ? Math.round(this.series.userOptions.actualIndexValues[this.point.x]) : serviceBar.nullValueText;

                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSizeValues[this.point.x],);
                  let color = configService.CheckIndexColoring(text2);

                  this.series.userOptions.tooltip[this.point.x] = text + "(" + text2 + ")";;

                  //Hiding value if segment is too small
                  const _yAxis = this.series.chart.yAxis[0];
                  const _segPx = Math.abs(_yAxis.toPixels(this.y, true) - _yAxis.toPixels(0, true));
                  const minSegPxForIndexLabel = popUp ? 22 : 10;
                  if (_segPx < minSegPxForIndexLabel || text === serviceBar.nullValueText || String(text).includes('NA')) {
                    return '';
                  }

                  return (
                    '<div style="text-align:center; line-height:1.3;"><div style="font-size:' + properties.dataLabelSize + ';">' + text + '</div>' +
                    '<div style="color:' + color + ';font-size:' + (parseFloat(properties.dataLabelSize) - 0.2) + 'rem;">(' + text2 + ')</div></div>'
                  );
                }

                if (properties.datalabelStyle == "sigChange") {
                  //extract each changeVs value
                  let changeText = this.series.userOptions.isPercentage ? (this.series.userOptions.changeValue[this.point.x]) * 100 :
                    this.series.userOptions.changeValue[this.point.x];
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let textCheck = configService.CheckLSorIScondition(configService.userRole, this.y, this.series.userOptions.sampleSizeValues[this.point.x]);
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? textCheck + (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '') : serviceBar.nullValueText;

                  // text = textCheck+ (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '');
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significanceValue[this.point.x];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  //include + if changeValue is positive
                  // if (parseFloat(changeText) > 0) {
                  //   changeText = "+" + changeText;
                  // }
                  let sigClass = this.series.userOptions.Significance_Value < this.series.userOptions.Sig_LowerLimt ? 'red' : this.series.userOptions.Significance_Value > this.series.userOptions.Sig_UpperLimt ? 'green' : 'black';
                  
                  //merge text+changeText+significance
                  let finalText: string;
                  let tooltipText: string;
                  
                  if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                    finalText = '<div style="text-align:center; line-height:1.3;">' +
                      '<div style="font-size:' + properties.dataLabelSize + ';">' + text + '</div>' +
                      (this.series.userOptions.roundedValue[this.point.x] != null && textCheck != 'I/S' ?
                        '<div style="color:black; font-size:' + properties.dataLabelSize + ';">(NA)</div>' : '') +
                      '</div>';

                    tooltipText = '<span>' +
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x] != null && textCheck != 'I/S' ? '<span>&nbsp;' +
                        '<span style="color:black; font-size:' + properties.dataLabelSize + ';">(NA)</span>' +
                        '</span>' : '') +
                      '</span>';
                  }
                  else {
                    finalText = '<div style="text-align:center; line-height:1.3;">' +
                      '<div style="font-size:' + properties.dataLabelSize + ';">' + text + '</div>' +

                      (this.series.userOptions.Significance_Value == 0 ?
                        '<div style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';">(' + (this.series.userOptions.Significance_Value + (this.series.userOptions.isPercentage ? '%' : '')) + ')</div>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x] != null && changeText != null && textCheck != 'I/S' ?
                        '<div style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</div>' : '')) +
                      '</div>' ;

                    tooltipText = '<span>' +
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +

                      (this.series.userOptions.Significance_Value == 0 ?
                        '<span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(' + (0 + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x] != null && changeText && textCheck != 'I/S' ? '<span>&nbsp' +
                        '<span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>' : '')) +
                      '</span>';
                  }
                  
                  //assign tooltip - this will always be set now even if label is hidden
                  this.series.userOptions.tooltip[this.point.x] = tooltipText;
                  // Hide label if segment is too small or value is null/NA-based px width of bar 
                  const _yAxis = this.series.chart.yAxis[0];
                  const _segPx = Math.abs(_yAxis.toPixels(this.y, true) - _yAxis.toPixels(0, true));
                  const minSegPxForSigLabel = popUp ? 30 : 20;
                  if (_segPx < minSegPxForSigLabel || text === serviceBar.nullValueText || String(text).includes('NA')) {
                    return '';
                  }
                  
                  //return the finalText
                  return finalText;
                }

                //significance and changeVs option is selected from datalabel property
                if (properties.datalabelStyle == "significance + changeVs") {
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  //extract each changeVs value
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significanceValue[this.point.x];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  //include + if changeValue is positive
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  //merge text+changeText+significance
                  let finalText = '<span>' +
                    '<span>' + text + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  //return the finalText
                  return (
                    finalText
                  );


                }
                if (properties.datalabelStyle == "change") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text + "  " +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '</span>' : '');
                  this.series.userOptions.tooltip[this.point.x] = finalText;

                  return (
                    finalText
                  );

                }

                if (properties.datalabelStyle == "ls") {


                  let text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                  
                  let finalText = '<b style="font-size:' + properties.dataLabelSize + ';">' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  // Hide label if segment is too small or value is null/NA-based px width of bar 
                  const _yAxis = this.series.chart.yAxis[0];
                  const _segPx = Math.abs(_yAxis.toPixels(this.y, true) - _yAxis.toPixels(0, true));
                  if (!popUp && (_segPx < 20 ||text === serviceBar.nullValueText || text.includes('NA'))) {
                    return '';
                  }

                  return finalText;
                }
                if (properties.datalabelStyle == "significance") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let sig = this.series.userOptions.significance[this.point.x];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  
                  let finalText = '<span style="font-size:' + properties.dataLabelSize + ';">' + text + (this.series.userOptions.roundedValue[this.point.x] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  // Hide label if segment is too small or value is null/NA-based px width of bar  
                  const _yAxis = this.series.chart.yAxis[0];
                  const _segPx = Math.abs(_yAxis.toPixels(this.y, true) - _yAxis.toPixels(0, true));
                  if (!popUp && (_segPx < 20 || text === serviceBar.nullValueText || text.includes('NA'))) {
                    return '';
                  }
                  
                  return (
                    finalText
                  )

                }
                if (properties.datalabelStyle == "default") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSizeValues[this.point.x],);

                  this.series.userOptions.tooltip[this.point.x] = text;

                  const shouldNudgeRight = typeof this.point?.plotX === 'number' && this.point.plotX < 25;
                  const nudgeStyle = shouldNudgeRight ? 'display:inline-block;transform:translateX(6px);' : '';
                  // Hide label if segment is too small or value is null/NA-based px width of bar 
                  const _yAxis = this.series.chart.yAxis[0];
                  const _segPx = Math.abs(_yAxis.toPixels(this.y, true) - _yAxis.toPixels(0, true));
                  if (!popUp && (_segPx < 20 || text === serviceBar.nullValueText || text.includes('NA'))) {
                    return '';
                  }

                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';' + nudgeStyle + '">' + text + '</span>'
                  );
                }
                if (properties.datalabelStyle == "datalabel") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage ? '%' : '') : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x] = text;

                  const shouldNudgeRight = typeof this.point?.plotX === 'number' && this.point.plotX < 25;
                  const nudgeStyle = shouldNudgeRight ? 'display:inline-block;transform:translateX(6px);' : '';
                  // Hide label if segment is too small or value is null/NA-based px width of bar 
                  const _yAxis = this.series.chart.yAxis[0];
                  const _segPx = Math.abs(_yAxis.toPixels(this.y, true) - _yAxis.toPixels(0, true));
                  if (!popUp && (_segPx < 20 || text === serviceBar.nullValueText || text.includes('NA'))) {
                    return '';
                  }
                  
                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';' + nudgeStyle + '">' + text + '</span>'
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  let sig = this.series.userOptions.significance[this.point.x];
                  let sig1 = this.series.userOptions.significance2[this.point.x];
                  let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                      '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }


                return !Number.isNaN(this.series.userOptions.roundedValue[this.point.x]) ? this.y : 'NA';

              },
          }
        },
      },
      series: this.seriesData1
    } as any);
        }
        else{


  // Ensure container exists
  const container = document.getElementById(container2);
  if (!container) {
    console.error('Chart container not found:', container2);
    return;
  }
   if (this.chart) {
    this.chart.destroy();
    this.chart = null;
  }
container.innerHTML = '';
  // Ensure container exists
 

this.ChartProperties = properties;
   this.accessSeriesValues(this.properties.datalabelStyle == 'lowSample');
  const popUp = this.popUp;
    let yAxisMaxValue = 0;
    let yAxisMinValue = 0;
    let maxDataValue = 0;
    let serviceBar = this.stackService;
    let sampleSizeConstant = this.stackService.sampleSizeConstant;
    // If there are more than 2 categories/bars, show 2 at a time and enable scroll
    const maxCategoriesToShow = 2;
    const numberOfTicks = 10; // number of axis division
    const sumArray = new Array<number>();
    const minArray = Array.from({ length: this.seriesData[0].data.length }, () => Number.MAX_SAFE_INTEGER);
    const updatedCategories = this.stackService.updatedCategories;
    let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
    const numPlotBands = this.chartCategories.length;
    const defaultCategories = this.chartCategories;
    let categoryImages = this.categoryImages;
    const numberOfSeries = Math.min(this.seriesData.length, this.stackService.customColors.length);
    const reversedColors = this.stackService.customColors.slice(0, numberOfSeries).reverse();
    const reversedColorsGradient = this.stackService.customColors1.slice(0, numberOfSeries).reverse();
    // Assign color for each series based on its index
    this.seriesData.forEach((series, index) => {
      series.actualColor = reversedColors[index % numberOfSeries];
    });

    // Initialize sumArray with zeros
    this.seriesData[0].data.forEach(() => sumArray.push(0));
    // Sum up values of each series at each index
    this.seriesData.forEach(series => {
      series.data.forEach((value: any, index: any) => {
        if (value > 0) {
          sumArray[index] += value;
        }
      });
    });
    maxDataValue = Math.max(...sumArray);
    maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.1);

    const tickInterval = Math.ceil(maxDataValue / numberOfTicks); //to calculate the intervals for axis

    // Populate the minArray with initial values
    for (let i = 0; i < this.seriesData[0].data.length; i++) {
      minArray.push(Number.POSITIVE_INFINITY);
    }

    // Iterate over each series and each data point within each series
    this.seriesData.forEach(series => {
      series.data.forEach((value: any, index: any) => {
        // Update the minimum value in minArray
        minArray[index] = Math.min(minArray[index], value);
        // Sum up negative values directly while updating minArray
        if (value < 0) {
          minArray[index] += value; // Subtract negative values to minArray
        }
      });
    });

    let minDataValue = Math.min(...minArray);
    minDataValue = minDataValue - Math.ceil(minDataValue * 0.1);
    yAxisMaxValue = this.ChartProperties.stacking ? 100 : maxDataValue;
    yAxisMinValue = this.ChartProperties.stacking ? 0 : minDataValue;

    //To display plotbands
    if (this.ChartProperties.plotBands) {
      for (let i = 0; i < numPlotBands; i += 2) {
        const from = i + 0.5;
        const to = from + 1;
        plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.stackService.plotBandsdark : this.stackService.plotBandsColor, from, to });
      }
    }

    //set the color of bars
    const globalColorMap = this._configService.getGlobalColorMap();
    
    if (this.ChartProperties.gradientBarColor) {
      this.seriesData.forEach((series, index) => {
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = reversedColorsGradient[index % numberOfSeries]; // Assign colors from customColors1
        }
      });
    }
    else if (this.ChartProperties.showPattern) {
      this.seriesData.forEach((series, index) => {
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = this.getPatternForImage(this.stackService.patternImages[index % this.stackService.PatterncustomColors.length]); // Assign colors in a cyclical manner
        }
      });
    }
    else {
      //applying colors in reverse order since series is reversed to stack from bottom to top     
      this.seriesData.forEach((series, index) => {
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = reversedColors[index % numberOfSeries];
        }
      });
    }

    const enableCategoryScroll = !popUp && this.chartCategories.length > maxCategoriesToShow;
    const xAxisMax = enableCategoryScroll
      ? maxCategoriesToShow - 1
      : this.chartCategories.length - 1;

    const containerEl = document.getElementById(container2);
    if (!containerEl) { return; }
    this.chart = Highcharts.chart(containerEl, {
      chart: {
        type: 'bar',
        backgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
        style: {
          fontFamily: this.stackService.textfont,
          color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
        }
      },
      exporting: {
        enabled: false
      },

      legend: this.stackService.customizeLegend(this.properties.showLegend,this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),

      title: {
        text:'',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          marginleft: '4%',
          fontFamily: this.stackService.textfont,
          fontSize: '2em'
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {
        // reversed: true,
        visible: true,
        lineWidth: 1,
        min: 0,
        max: xAxisMax,
        categories: this.chartCategories,
        gridLineWidth: this.properties.xaxisgridlines ? 1 : 0,

        labels: {
          rotation: this.stackService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          useHTML: popUp,
          style: {
            color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
            fontSize: popUp ? '0.7rem' : '12px',
            whiteSpace: 'normal',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
            const raw = String(this.value ?? '');
            const esc = (s: string) => s
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&#39;');

            if (popUp) {
              const chart = this.axis.chart;
              const categories = (this.axis.categories || []) as any[];
              const chartWidth = chart.plotWidth || 400;
              const numCategories = Math.max(categories.length, 1);
              const baseWidth = Math.floor(chartWidth / numCategories);
              const padding = 12;
              const minWidth = 120;
              const labelWidth = Math.max(baseWidth - padding, minWidth);

              return `<div style="width:${labelWidth}px; white-space:normal; overflow:visible; text-overflow:clip; word-break:break-word; line-height:1.2; text-align:center; margin:0 auto;" title="${esc(raw)}">${esc(raw)}</div>`;
            }

            return raw;
          },
        },
        scrollbar: {
          enabled: enableCategoryScroll,
          height: 6, // Adjust the height of the scrollbar as needed
           barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          buttonBackgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          buttonBorderWidth: 0,
          buttonArrowColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        tickLength: 0,
        plotBands: plotBandsConfig,
      },
      yAxis: {
        // visible: false,
        // gridLineWidth: this.ChartProperties.gridlines,
        
    visible: true,
    gridLineWidth: this.ChartProperties.yaxisgridlines ? 1 : 0,

        labels: {
          enabled: false,
          style: {
            color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          },
        },
        // plotLines: [{
        //   value: 0,
        //   width: 1,
        //   zIndex: 4,
        //   visible:true
        // }],
        min: yAxisMinValue,
        max: yAxisMaxValue,
        tickInterval: this.ChartProperties.stacking ? 10 : tickInterval,
        title: {
          text: '',
          fontFamily: this.stackService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },

        formatter: function () {
             if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
            const content =
               `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${this.point.series.name}: </span>
            <b style="margin-left:4px;">${text}</b>
          </div>`;
 
  return content;
//         if (isDefaultTooltip != 'default') {
//           const content =
//                `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
//             <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
//             <span>${this.point.series.name}: </span>
//             <b style="margin-left:4px;">${text}</b>
//           </div>`;
 
//   return content;

          
//           }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 999; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.series.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }
        },
      } as any,

      plotOptions: {
        series: {
          animation: false,
        },
        bar: {
           
          stacking: this.ChartProperties.stacking ? 'percent' : 'normal',
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: this.ChartProperties.allowOverlap,
            enabled: this.ChartProperties.showDataLabel,
            color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
            verticalAlign: this.ChartProperties.dataLabelPosition,
            useHTML: true,
            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
              fontSize: this.ChartProperties.dataLabelSize,
              fontFamily: this.stackService.textfont,
              fontWeight: "normal"
            },
            formatter: function (this: any) {
              let sigcolor;
              const upwardTriangle = '&#9650';
              const downwardTriangle = '\u25BC';
              const upColor = 'green';
              const downColor = 'red';
              let text; let changeText; let sig; let sColor;
              let finalText = "";

              if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                finalText = "NA";
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance + changeVs")
              {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];
                sColor = sig > 0 ? upColor : (sig < 0 ? 'red' : '');
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let changeColor = properties.darkTheme ? 'white' : 'black';

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }

                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${sColor};">${s}</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }


              if (properties.datalabelStyle == "datalabel") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                finalText = (
                  '<span >' + text + '</span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;

              }

              if (properties.datalabelStyle == "change") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];

                let changeColor = properties.darkTheme ? 'white' : 'black';

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }


                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                sig = this.series.userOptions.significanceValue[this.point.x];
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');

                finalText = (
                  '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance2") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];;
                let sig1 = this.series.userOptions.significanceValue2[this.point.x];;
                sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }


                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${sColor};">${s}</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == 'lowSample') {
                text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'LS';
                finalText = (
                  '<span>' +
                  text +
                  '</span> ' +
                  '<span style="opacity: 0.5"></span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }
              finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
              this.series.userOptions.tooltip[this.point.x] = finalText;
              return finalText;
            }
          }
        },
      },
      series: this.seriesData
    } as any);
  }
  }


  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.stackService.applycustomization(event,item, this.ChartProperties)
    this.renderChart2('chart-container'+this.id,this.data, this.ChartProperties);
  }

  patternselect(ispattern: boolean) {
    this.ChartProperties.showPattern = ispattern
    this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample');
    this.renderChart2('chart-container',this.data, this.ChartProperties);
  }

  userselectedproperties() {
    this.data["properties"][0].showPattern = this.ChartProperties.showPattern;
    this.data["data"] = this.StackChartData;
    this.data["properties"][0] = this.ChartProperties;
    return JSON.stringify(this.data).toString();
  }

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }
  private getPointWidth(containerId: string, categoryCount: number): number | undefined {
  const el = document.getElementById(containerId);
  if (!el || categoryCount <= 0) return undefined;

  const plotWidth = el.clientWidth || 800;
  // approx available px per category (tweak multiplier)
  const perCat = plotWidth / categoryCount;

  const width = Math.floor(perCat * 0.18); // tweak 0.15–0.25
  return Math.max(10, Math.min(width, this.popUp ? 60 : 45));
}
private getStackTotalsMax(series: any[]): number {
  if (!series?.length) return 0;
  const len = series[0]?.data?.length || 0;

  const totals = Array(len).fill(0);

  series.forEach(s => {
    (s.data || []).forEach((v: any, i: number) => {
      const num = typeof v === 'number' ? v : Number(v) || 0;
      if (!isNaN(num)) totals[i] += num;
    });
  });

  return Math.max(...totals, 0);
}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

}
